<template>
  <div>
    <v-text-field
      v-model="search"
      append-icon="mdi-magnify"
      label="Search"
      outlined
      dense
    ></v-text-field>

    <v-row justify="center">
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="items"
          :footer-props="{
            'items-per-page-options': [50, 100, 150, 200],
          }"
          :search="search"
          dense
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>PLATFORM UPLOAD HISTORY</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-btn color="accent" @click="getPlatformUploadHistory"
                ><v-icon> mdi-refresh </v-icon> Refresh</v-btn
              >
            </v-toolbar>
          </template>
          <template v-slot:[`item.failedProducts`]="{ item }">
            <tr>
              <td>
                <v-btn text color="error" @click="getFailed(item)"
                  >FAILED <v-icon right>mdi-eye-remove</v-icon></v-btn
                >
              </td>
            </tr>
          </template>
          <template v-slot:[`item.successfulProducts`]="{ item }">
            <tr>
              <td>
                <v-btn text color="success" @click="getSuccessful(item)"
                  >SUCCESSFULL <v-icon right>mdi-eye-check</v-icon></v-btn
                >
              </td>
            </tr>
          </template>

          <template v-slot:[`item.date`]="{ item }">
            <tr>
              <td>
                {{ new Date(item.date).toLocaleString() }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-dialog persistent v-model="statusDialog" width="unset">
      <StatusInfo
        :responseMessage="responseMessage"
        :filename="filename"
        :pending="pending"
        @close="reset"
        :textColor="textColor"
      ></StatusInfo>
    </v-dialog>

    <v-dialog v-model="showProductsDialog">
      <UploadedItemsList
        :title="listTitle"
        :products="products"
        :icon="icon"
      ></UploadedItemsList>
    </v-dialog>
  </div>
</template>

<script>
import UploadedItemsList from "../Platforms/UploadedItemsList.vue";
import StatusInfo from "../organisms/StatusInfo";

export default {
  name: "PlatformUploadHistory",
  props: {},
  components: {
    UploadedItemsList,
    StatusInfo,
  },
  data: () => ({
    headers: [
      {
        text: "Uploader",
        align: "start",
        value: "uploader",
        divider: true,
        class: "footer basic--text",
        width: "15%",
      },
      {
        text: "Platform",
        align: "start",
        value: "platform",
        divider: true,
        class: "footer basic--text",
        width: "10%",
      },

      {
        text: "",
        align: "start",
        value: "successfulProducts",
        divider: true,
        class: "footer basic--text",
        width: "15%",
      },
      {
        text: "",
        align: "start",
        value: "failedProducts",
        divider: true,
        class: "footer basic--text",
        width: "15%",
      },
      {
        text: "Date",
        align: "start",
        value: "date",
        divider: true,
        class: "footer basic--text",
        width: "55%",
      },
    ],
    items: [],
    search: "",
    showProductsDialog: false,
    listTitle: "",
    products: [],
    statusDialog: false,
    responseMessage: "",
    filename: "",
    pending: true,
    textColor: "basic--text",
    icon: "",
  }),
  computed: {},
  methods: {
    async getPlatformUploadHistory() {
      try {
        const response = await this.$store.dispatch("getPlatformUploadHistory");
        this.items = response.data;
        this.items.sort(function (a, b) {
          return new Date(b.date) - new Date(a.date);
        });
      } catch (error) {
        console.log(error);
      }
    },
    async getSuccessful(item) {
      this.statusDialog = true;
      try {
        const response = await this.$store.dispatch(
          "getPlatformUploadHistorySuccess",
          item.id
        );
        this.products = response.data;
        this.listTitle = "Successfully uploaded products";
        this.statusDialog = false;
        this.showProductsDialog = true;
      } catch (error) {
        console.log(error);

        if (error.response) {
          if (error.response.status == 404) {
            this.products = [];
            this.listTitle = "Successfully uploaded products";
            this.statusDialog = false;
            this.showProductsDialog = true;
          } else {
            this.textColor = "red--text";
            this.pending = false;
            this.showErrors(error.response.status, error.response.data);
          }
        } else {
          this.pending = false;
          this.textColor = "red--text";
          // anything else
          this.filename = "feeling_blue.svg";
          this.responseMessage =
            "SORRY... Something went wrong when trying to get successfully uploaded products.";
        }
      }
    },
    async getFailed(item) {
      this.statusDialog = true;
      try {
        const response = await this.$store.dispatch(
          "getPlatformUploadHistoryFailed",
          item.id
        );
        this.products = response.data;
        this.listTitle = "Products failed on upload";
        this.statusDialog = false;
        this.showProductsDialog = true;
      } catch (error) {
        console.log(error);
        if (error.response) {
          if (error.response.status == 404) {
            this.products = [];
            this.listTitle = "Products failed on upload";
            this.statusDialog = false;
            this.showProductsDialog = true;
          } else {
            this.textColor = "red--text";
            this.pending = false;
            this.showErrors(error.response.status, error.response.data);
          }
        } else {
          this.pending = false;
          this.textColor = "red--text";
          // anything else
          this.filename = "feeling_blue.svg";
          this.responseMessage =
            "SORRY... Something went wrong when trying to get failed on upload products.";
        }
      }
    },
    reset() {},
    showErrors(status, message) {
      // client received an error response (5xx, 4xx)
      this.responseMessage = message;
      switch (status) {
        case 400:
          this.filename = "empty.svg";
          break;
        case 401:
          //clear local storage, push to login
          localStorage.clear();
          this.$router.push("login");
          break;
        case 403:
          this.filename = "403_forbidden.svg";
          break;
        case 404:
          this.responseMessage = "Not found [404]. Please contact TECH team.";
          this.filename = "void.svg";
          break;
        case 406:
          //clear local storage, push to login
          localStorage.clear();
          this.$router.push("login");
          break;
        case 500:
          this.filename = "server_down.svg";
      }
    },
  },
  async mounted() {
    await this.getPlatformUploadHistory();
  },
};
</script>